import React, { useState, useEffect } from 'react';
import DropDown from '../../../../../components/DropDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCommentDots,
  faFileCircleCheck,
  faGear,
  faPrint,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';
import RCDropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';
import PropTypes from 'prop-types';
import CustomToast from '../../../../../components/Toast';
import { useNavigate, useParams } from 'react-router-dom';
import { bytesToBase64 } from '../../../../../utils/pdfUtils';
import { useCheckIsStudentPdfExistMutation, usePdfGeneratorMutation, useStudentPdfGeneratorMutation, useViewStudentPdfMutation } from '../../../../../features/authentication/pdfGeneratorApiSlice';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';
import HelpRequest from '../../../../dashboard/components/Modals/HelpRequest';
import appConfig from '../../../../../app-config';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import { getAudioPlayerImage } from '../utils/GetAudioPlayerImage';
import ProgressButton from '../../../../../components/ProgressButton';
import PageSize from '../../../../../enums/pageSize';


const StandardPrintingHeader = ({
  settings,
  updateSettings,
  fontSizeValue,
  fontStyleValue,
  mcSpaceValue,
  mcstyleValue,
  answerKeyValue,
  assignmentName,
  assignmentId,
  selectedAnswerOptions,
  setSelectedAnswerOptions,
  isLoading,
  stackQuestions,
  clearCurrentSession,
  resetToDefault,
  isTwoColumnStack
}) => {
  const [selectedFontStyle, setSelectedFontStyle] = useState();
  const [selectedFontSize, setSelectedFontSize] = useState();
  const [selectedMCSpacing, setSelectedMCSpacing] = useState();
  const [selectedMCStyle, setSelectedMCStyle] = useState();
  const [selectedAnswerKey, setSelectedAnswerKey] = useState();
  const [visible, setVisible] = useState(false);
  const [formatOptionvisible, setFormatOptionvisible] = useState(false);
  const [isOpenFeedbackModal, setIsOpenFeedbackModal] = useState(false);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [confirmationTitle, setConfirmationTitle] = useState('');
  const [selectedFormatOption, setSelectedFormatOption] = useState(false);

  const [pdfGenerator] = usePdfGeneratorMutation();
  const [studentPdfGenerator] = useStudentPdfGeneratorMutation();
  const [viewStudentPdf] = useViewStudentPdfMutation();
  const [checkIsStudentPdfExist] = useCheckIsStudentPdfExistMutation();
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [isStudentPdfGenerating, setIsStudentPdfGenerating] = useState(false);
  const [isPdfDownloading, setIsPdfDownloading] = useState(false);
  const [isStudentPdfExist, setIsStudentPdfExist] = useState(false);
  const navigate = useNavigate();
  const baseUrl = appConfig.apiBaseUrl;
  const { isAssessment } = useParams();

  const fontStyle = [
    {
      id: 'Times New Roman',
      name: 'Default'
    },
    {
      id: 'arial',
      name: 'Arial'
    },
    {
      id: 'comic Sans MS',
      name: 'Comic Sans'
    },
    {
      id: 'Courier',
      name: 'Courier'
    },
    {
      id: 'Tahoma',
      name: 'Tahoma'
    },
    {
      id: 'Times New Roman',
      name: 'Times New Roman'
    },
    {
      id: 'Verdana',
      name: 'Verdana'
    }
  ];

  const fontSize = [
    {
      id: 10,
      name: '10 pt'
    },
    {
      id: 12,
      name: '12 pt'
    },
    {
      id: 14,
      name: '14 pt'
    },
    {
      id: 16,
      name: '16 pt'
    },
    {
      id: 20,
      name: '20 pt'
    },
    {
      id: 24,
      name: '24 pt'
    }
  ];

  const mcSpacing = [
    {
      id: 1,
      name: 'Single'
    },
    {
      id: 15,
      name: '1.5'
    },
    {
      id: 2,
      name: 'Double'
    }
  ];

  const mcStyle = [
    {
      id: 0,
      name: '1 2 3'
    },
    {
      id: 1,
      name: 'a b c'
    },
    {
      id: 2,
      name: 'A B C'
    },
    {
      id: 3,
      name: '1. 2. 3.'
    },
    {
      id: 4,
      name: 'a. b. c.'
    },
    {
      id: 5,
      name: 'A. B. C.'
    },
    {
      id: 6,
      name: '(A) (B) (C)'
    }
  ];

  const answerKey = [
    {
      id: 0,
      name: 'None'
    },
    {
      id: 1,
      name: 'Compact'
    },
    {
      id: 2,
      name: 'Single Line'
    }
  ];

  const answerOptions = [
    {
      id: 1,
      name: 'Display Answers',
      checkbox: true
    },
    {
      id: 2,
      name: 'CR Answer Space',
      checkbox: true
    },
    {
      id: 3,
      name: 'MC Answer Space',
      checkbox: true
    },
    {
      id: 4,
      name: 'Fill-in Answer Space',
      checkbox: true
    },
    {
      id: 5,
      name: 'Remove All Answer Space',
      checkbox: false
    }
  ];

  const formatOptions = [
    {
      id: 0,
      name: 'Stack All Questions (2 Column)'
    },
    {
      id: 1,
      name: 'Clear Current Session Changes'
    },
    {
      id: 2,
      name: 'Reset All'
    }
  ];

  useEffect(() => {
    if(assignmentId)
      checkStudentPdfExist();
  }, []);

  const handleFontStyle = (event) => {
    const selectedFont = event.target.value;
    setSelectedFontStyle(selectedFont);
    updateSettings({ fontStyleData: selectedFont });
    CustomToast('Font Style/Size Changed', 'info');
  };

  const handleFontSize = (event) => {
    const selectedFont = parseInt(event.target.value);
    setSelectedFontSize(selectedFont);
    updateSettings({ fontSizeData: selectedFont });
    CustomToast('Font Style/Size Changed', 'info');
  };

  const handleMCSpacing = (event) => {
    const selectedSpacing = parseInt(event.target.value);
    setSelectedMCSpacing(selectedSpacing);
    updateSettings({ mcSpacingData: selectedSpacing });
    CustomToast('MC Spacing Changed', 'info');
  };

  const handleMCStyle = (event) => {
    const selectedStyle = parseInt(event.target.value);
    setSelectedMCStyle(selectedStyle);
    updateSettings({ mcStylingData: selectedStyle });
    CustomToast('MC Style Changed', 'info');
  };

  const handleAnswerKey = (event) => {
    const selectedAnswer = parseInt(event.target.value);
    setSelectedAnswerKey(selectedAnswer);
    updateSettings({ answerKey: selectedAnswer });
    CustomToast('Answer Key Changed', 'info');
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleChange = (e) => {
    const selectedOption = parseInt(e.key);
    if (selectedOption == 5) {
      setSelectedAnswerOptions([]);
      updateSettings({
        displayAnswer: false,
        crAnswerSpace: false,
        mcAnswerSpace: false,
        fiAnswerSpace: false
      });
    }
    else {
      updateAnswerOptions(selectedOption);
      if (selectedAnswerOptions.includes(selectedOption)) {
        const updatedOptions = selectedAnswerOptions.filter(id => id != selectedOption);
        setSelectedAnswerOptions(updatedOptions);
      }
      else
        setSelectedAnswerOptions((prevData) => {
          return [...prevData, selectedOption];
        });
    }
  };

  const updateAnswerOptions = (selectedOption) => {
    switch (selectedOption) {
    case 1:
      updateSettings({ displayAnswer: !settings.displayAnswer });
      break;
    case 2:
      updateSettings({ crAnswerSpace: !settings.crAnswerSpace });
      break;
    case 3:
      updateSettings({ mcAnswerSpace: !settings.mcAnswerSpace });
      break;
    case 4:
      updateSettings({ fiAnswerSpace: !settings.fiAnswerSpace });
      break;
    }
  };

  const menu = (
    <Menu className='w-100' multiple onSelect={handleChange} onDeselect={handleChange}>
      {answerOptions.map((item, index) => (
        <MenuItem key={item.id} className='border-0 fs-14'>
          {item.checkbox && (
            <div className="form-check cursor-pointer">
              <input
                key={`name${item.id}`}
                type="checkbox"
                className="form-check-input"
                checked={selectedAnswerOptions.includes(item.id)}
                name={'check-' + index}
                id={'check-' + index + item.id}
                disabled
              />
              <div className="mb-0">
                <div htmlFor={'check-' + index}>{item.name}</div>
              </div>
            </div>
          )}
          {!item.checkbox && <div className='cursor-pointer'>{item.name}</div>}
        </MenuItem>
      ))}
    </Menu>
  );

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const initialData = () => {
    setSelectedFontSize(fontSizeValue);
    setSelectedFontStyle(fontStyleValue);
    setSelectedMCSpacing(mcSpaceValue);
    setSelectedMCStyle(mcstyleValue);
    setSelectedAnswerKey(answerKeyValue);
  };

  const handlePrintPDF = async () => {
    if (isPdfGenerating) return;

    setIsPdfGenerating(true);
    let options = handlePrintOptions(assignmentName);

    try {
      var pdfBlob = await pdfGenerator(options).unwrap();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${assignmentName}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error(error);
    }
    setIsPdfGenerating(false);
  };

  const handlePrintOptions = (fileName, isStudentPdf = false) => {
    const contentWrapper = document.getElementById('print-content-container');
    const htmlString = contentWrapper.innerHTML;

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const divOptions = tempContainer.querySelectorAll('.no-print');
    if (divOptions) {
      divOptions.forEach((option) => {
        option.classList.add('d-none');
      });
    }

    const ulElements = tempContainer.querySelectorAll('ul');
    ulElements.forEach((ul) => {
      ul.style.margin = '0';
    });

    const audioElements = tempContainer.querySelectorAll('audio');
    audioElements.forEach(aud => {
      aud.outerHTML = getAudioPlayerImage();
    });

    const paddedContainer = tempContainer.querySelector('#paddedContainer');
    paddedContainer.style.paddingLeft = '0';
    paddedContainer.style.paddingRight = '0';
    paddedContainer.classList.remove('border', 'border-dark');

    const questionLayouts = tempContainer.querySelectorAll('.question-layout');
    questionLayouts.forEach(item => {
      item.style.display = 'block';
    });

    if (isTwoColumnStack) {
      tempContainer.querySelectorAll('.disable-Pointer-Events table').forEach(table => {
        table.querySelectorAll('td, th').forEach(cell => {
          cell.style.removeProperty('width');
          cell.style.removeProperty('min-width');
          cell.style.removeProperty('max-width');
        });
      });

      tempContainer.querySelectorAll(
        '.drop-container-single img, .drop-container-multiple img'
      ).forEach(img => {
        img.style.removeProperty('width');
        img.style.removeProperty('min-width');
        img.style.removeProperty('max-width');
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
      });
    }
    
    const base64Encoded = bytesToBase64(new TextEncoder().encode(tempContainer.innerHTML));
    const options = {
      htmlContent: base64Encoded,
      OutputFileName: `${fileName}`,
      PageSize: PageSize.A4
    };

    if (isStudentPdf) {
      options.AssignmentId = assignmentId;
      options.AssignmentName = assignmentName;
    }

    return JSON.stringify(options);
  };

  const handleCreateStudentPdf = async () => {
    if (isStudentPdfGenerating) return;

    setIsStudentPdfGenerating(true);
    let fileName = 'Castle_Assignment_' + assignmentId;
    let options = handlePrintOptions(fileName, true);

    try {
      var response = await studentPdfGenerator(options);
      var pdfBlob = response.data;
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${fileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(pdfUrl);
      setIsStudentPdfExist(true);
    } catch (error) {
      console.log(error);
    }
    setIsStudentPdfGenerating(false);
  };

  const handleViewStudentPdf = async () => {
    if (isPdfDownloading) return;

    setIsPdfDownloading(true);

    try{
      var options = {
        assignmentId: assignmentId
      };

      const response = await viewStudentPdf(options);
      var pdfBlob = response.data;
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `Castle_Assignment_${assignmentId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.log(error);
    }   
    setIsPdfDownloading(false);
  };

  useEffect(() => {
    initialData();
  }, [fontSizeValue, fontStyleValue, mcSpaceValue, mcstyleValue, answerKeyValue]);

  const handleFormatOptionChange = (id) => {
    let title = '';
    let message = '';

    switch (id) {
    case 0:
      title = 'Stack All Questions';
      message = `If you have placed any questions in a stack, this option will<br/>override those changes and place all questions in the ${isAssessment ? 'assessment' : 'assignment'} into stacks.<br/>Are you sure you want to stack all questions?`;
      break;
    case 1:
      title = 'Clear Recent Changes';
      message = 'Are you sure you want to clear all recent changes you made during this session?';
      break;
    case 2:
      title = 'Reset All';
      message = 'Are you sure you want to reset to default format settings?';
      break;
    }

    setSelectedFormatOption(id);
    setConfirmationTitle(title);
    setConfirmationMessage(message);
    setIsOpenConfirmationModal(true);
  };

  const formatMenu = (
    <Menu
      className="w-100"
      onClick={(e) => {
        handleFormatOptionChange( Number(e.key));
        setFormatOptionvisible(false);
      }}
    >
      {formatOptions.map((item) => (
        <MenuItem key={item.id} className="border-0 fs-14">
          <div className="cursor-pointer">{item.name}</div>
        </MenuItem>
      ))}
    </Menu>
  );

  const handleConfirmationOnSave = (optionId) => {
    setIsOpenConfirmationModal(false);

    switch (optionId) {
    case 0:
      stackQuestions();
      break;
    case 1:
      clearCurrentSession();
      break;
    case 2:
      resetToDefault();
      break;
    }
  };

  const checkStudentPdfExist = async () => {
    var response = await checkIsStudentPdfExist([assignmentId]).unwrap();
    setIsStudentPdfExist(response.isStudentPdfExist);
  };

  return (
    <>
      {isLoading ? (
        <div className='print-header mb-3 p-4'>
          <SkeletonGrid
            rowCount={1}
            colCount={7}
            className='p-3' />
          <div className='mt-3 text-end'>
            <SkeletonGrid
              rowCount={1}
              colCount={2}
              className='p-3' />
          </div>
        </div>
      ) : (
        <div className="print-header mb-4 fs-14">
          <div className="d-flex gap-3 print-header-content">
            <div className="col">
              <DropDown
                label="Font Style"
                value={fontStyle}
                onChangeHandler={handleFontStyle}
                selectedValue={selectedFontStyle}
              />
            </div>
            <div className="col">
              <DropDown
                label="Font Size"
                value={fontSize}
                onChangeHandler={handleFontSize}
                selectedValue={selectedFontSize}
              />
            </div>
            <div className="col">
              <DropDown
                label="MC Spacing"
                value={mcSpacing}
                onChangeHandler={handleMCSpacing}
                selectedValue={selectedMCSpacing}
              />
            </div>
            <div className="col">
              <DropDown
                label="MC Style"
                value={mcStyle}
                onChangeHandler={handleMCStyle}
                selectedValue={selectedMCStyle}
              />
            </div>
            <div className="col">
              <DropDown
                label="Answer Key"
                value={answerKey}
                onChangeHandler={handleAnswerKey}
                selectedValue={selectedAnswerKey}
              />
            </div>
            <div
              className="print-header-select answer-option"
              id="anwerOptions">
              <RCDropdown
                trigger={['click']}
                onVisibleChange={handleVisibleChange}
                visible={visible}
                closeOnSelect={false}
                overlay={menu}
                animation="slide-up"
                getPopupContainer={() => document.getElementById('anwerOptions')}>
                <div className="rc-dropdown-options d-flex align-items-center cursor-pointer">
                  <FontAwesomeIcon icon={faFileCircleCheck} className="print-select-icon " />
                  <span>Answer Options</span>
                </div>
              </RCDropdown>
            </div>
            <div className="print-header-select answer-option" id='formatOptions'>
              <RCDropdown
                trigger={['click']}
                onVisibleChange={()=>setFormatOptionvisible(!formatOptionvisible)}
                visible={formatOptionvisible}
                closeOnSelect={true}
                overlay={formatMenu}
                animation="slide-up"
                getPopupContainer={() => document.getElementById('formatOptions')}>
                <div className="rc-dropdown-options d-flex align-items-center cursor-pointer">
                  <FontAwesomeIcon icon={faGear} className="print-select-icon " />
                  <span>Format Options</span>
                </div>
              </RCDropdown>
            </div>
          </div>
          <div className="button-container d-flex align-items-center justify-content-between">
            <div className="d-flex gap-4 btn-link flex-wrap">
              <div className="d-flex gap-1 align-items-center flex-shrink-0 cursor-pointer">
                <FontAwesomeIcon icon={faQuestionCircle} />
                <a className='btn-link' target="_blank" href={`${baseUrl}/Documents/Castle%20Learning_Assignment%20Printing%20FAQ.pdf`} rel="noreferrer"> FAQ & Tips </a>
              </div>
              <div className="d-flex gap-1 align-items-center flex-shrink-0 cursor-pointer">
                <FontAwesomeIcon icon={faCommentDots} />
                <span onClick={() => setIsOpenFeedbackModal(true)}>Feedback</span>
              </div>
            </div>
            <div className="d-flex gap-3 flex-wrap">
              <button className="btn-classicPrint d-flex align-items-center gap-1 flex-shrink-0 d-none">
                <FontAwesomeIcon icon={faPrint} />
                <span>Classic Print</span>
              </button>
              <button className="btn btn-castleWhite" onClick={handleBackButtonClick}>
                Back
              </button>
              <ProgressButton
                isLoading={isPdfDownloading}
                onClick={handleViewStudentPdf}
                loadingLabel="PDF Downloading"
                label="View Student PDF"
                className="btn btn-castleWhite"
                disabled={!isStudentPdfExist}
              />
              <ProgressButton
                isLoading={isStudentPdfGenerating}
                onClick={handleCreateStudentPdf}
                loadingLabel="Generating PDF"
                label="Create Student PDF"
                className="btn btn-studentPDF"
              />
              <ProgressButton
                isLoading={isPdfGenerating}
                onClick={handlePrintPDF}
                loadingLabel="Generating PDF"
                label="Print to PDF"
                className="btn btn-castleRed"
              />
            </div>
          </div>
        </div>
      )}
      {isOpenFeedbackModal &&
        <HelpRequest
          modalData={isOpenFeedbackModal}
          setModalData={setIsOpenFeedbackModal}
          modalSubmissionType='feedback'
        />
      }

      {isOpenConfirmationModal &&
        <ConfirmationModal
          isOpen={isOpenConfirmationModal}
          onClose={() => setIsOpenConfirmationModal(false)}
          onSave={() => handleConfirmationOnSave(selectedFormatOption)}
          contentWidth={'35%'}
          buttonPosition={'center'}
          titleName={confirmationTitle}
          content={confirmationMessage}
          cancelButton={'No'}
          confirmButton={'Yes'}
        />
      }
    </>
  );
};

StandardPrintingHeader.propTypes = {
  fontSizeValue: PropTypes.number,
  fontStyleValue: PropTypes.string,
  mcSpaceValue: PropTypes.number,
  mcstyleValue: PropTypes.number,
  answerKeyValue: PropTypes.number,
  updateSettings: PropTypes.func,
  assignmentName: PropTypes.string,
  assignmentId: PropTypes.number,
  selectedAnswerOptions: PropTypes.array,
  setSelectedAnswerOptions: PropTypes.func,
  settings: PropTypes.object,
  isLoading: PropTypes.bool,
  stackQuestions: PropTypes.func,
  clearCurrentSession: PropTypes.func,
  resetToDefault: PropTypes.func,
  isTwoColumnStack: PropTypes.bool
};

export default StandardPrintingHeader;
